// extracted by mini-css-extract-plugin
export default {"main":"m_D","container":"m_F","inner":"m_G","section":"m_Q","blueBlock":"m_2","single":"m_3","block":"m_4"};